import { inject } from '@angular/core';
import type { UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { of, type Observable } from 'rxjs';
import { catchError, filter, map, take, timeout } from 'rxjs/operators';
import { UserStore } from '../user';
import { FETCH_TIMEOUT } from './models';

type SettledStatus = 'success' | 'error';

export const userLoadedGuard = () => {
    const userStore = inject(UserStore);
    const router = inject(Router);

    return waitForSettledStatus(userStore.meStatus$).pipe(
        map((meStatus) => {
            const user = userStore.me();
            const meError = userStore.meQuery.error();
            const org = userStore.org();

            let result: boolean | UrlTree;
            if (meStatus === 'success' && user && org) {
                result = true;
            } else if (meStatus === 'error' && meError?.status === 404) {
                result = router.createUrlTree(['/onboarding']);
            } else if (meStatus === 'success' && !org) {
                result = router.createUrlTree(['/service-unavailable']);
            } else {
                result = router.createUrlTree(['/login']);
            }
            return result;
        }),
        timeout(FETCH_TIMEOUT),
        catchError(() => of(router.createUrlTree(['/service-unavailable'])))
    );
};

function waitForSettledStatus(status$: Observable<string>) {
    return status$.pipe(filter(isSettledStatus), take(1));
}

function isSettledStatus(status: string): status is SettledStatus {
    return status === 'success' || status === 'error';
}
